import {
    NOTIFICATION_CATALOG,
    NOTIFICATION_SETTINGS_GROUPS,
    NOTIFICATION_SETTINGS_SECTIONS,
    type NotificationTypeKey,
} from '@apps/web/lib/notification_catalog.generated';

export type NotificationSettingsItem = {
    readonly key: NotificationTypeKey;
    readonly label: string;
    readonly helperText: string;
    readonly keys: ReadonlyArray<NotificationTypeKey>;
};

export type NotificationSettingsSection = {
    readonly title: string;
    readonly items: ReadonlyArray<NotificationSettingsItem>;
};

type NotificationSettingsVisibility = {
    readonly planOfCareDutyMonitoringEnabled: boolean;
};

type PlanOfCareDutyMonitoringSettings = {
    readonly plan_of_care_duty_monitoring_available?: boolean | null;
    readonly plan_of_care_duty_monitoring_enabled?: boolean | null;
};

export type NotificationSettingsGroupCheckedState = boolean | 'indeterminate';

export function isPlanOfCareDutyMonitoringEnabled(
    generalSettings: PlanOfCareDutyMonitoringSettings | null | undefined,
): boolean {
    return (
        generalSettings?.plan_of_care_duty_monitoring_available === true &&
        generalSettings.plan_of_care_duty_monitoring_enabled === true
    );
}

export function getNotificationSettingsGroupCheckedState(
    keys: ReadonlyArray<NotificationTypeKey>,
    isEnabled: (key: NotificationTypeKey) => boolean,
): NotificationSettingsGroupCheckedState {
    const enabledCount = keys.filter(isEnabled).length;
    if (enabledCount === 0) {
        return false;
    }
    return enabledCount === keys.length ? true : 'indeterminate';
}

export function getVisibleNotificationSettingsSections({
    planOfCareDutyMonitoringEnabled,
}: NotificationSettingsVisibility): ReadonlyArray<NotificationSettingsSection> {
    return NOTIFICATION_SETTINGS_SECTIONS.map((section) => ({
        title: section.title,
        items: section.rows
            .filter(
                (key) =>
                    key !== 'plan_of_care_incomplete' ||
                    planOfCareDutyMonitoringEnabled,
            )
            .map((key) => ({
                key,
                label: NOTIFICATION_CATALOG[key].label,
                helperText: NOTIFICATION_CATALOG[key].helperText ?? '',
                keys: NOTIFICATION_SETTINGS_GROUPS[key] ?? [key],
            })),
    })).filter((section) => section.items.length > 0);
}
